/* eslint-disable import/prefer-default-export */
export const getAllTreatments = ({ flags }) => {
  if (flags.treatments) {
    return flags.treatments;
  }
  return {};
};



// WEBPACK FOOTER //
// ./src/selectors/split.js